export default{
    
    lista:{
        method:'get',
        url:'declaracao/suspencao/trabalhador/avulso/lista'
    },
    pesquisa:{
        method:'get',
        url:'boletins/tabela/pesquisa{/id}'
    },
    cadastra:{
        method:'post',
        url:'declaracao/suspencao/trabalhador/avulso/cadastro'
    },
    delete:{
        method:'delete',
        url:'declaracao/suspencao/trabalhador/avulso/deletar{/id}'
    },
    deletecodigo:{
        method:'delete',
        url:'declaracao/suspencao/trabalhador/avulso/codigo/deletar{/id}'
    },
    editar:{
        method:'get',
        url:'declaracao/suspencao/trabalhador/avulso/editar{/id}'
    },
    update:{
        method:'post',
        url:'declaracao/suspencao/trabalhador/avulso/update'
    },
    numero:{
        method:'post',
        url:'boletins/cartaoponto/numero/max'
    }
}
